
class gtagModule
{
    static run () {

        window.dataLayer = window.dataLayer || [];
        function gtag(){ dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'UA-166259985-2');

    }
}

export default gtagModule;
